import { Col, Row, Skeleton } from "antd";
import styles from "./PaidPayments.module.css";
import { TextComponent } from "../../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import img from "../../../../assets/vendorimg6.png";
import { useDispatch } from "react-redux";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { useEffect, useState } from "react";

const vendorInfo = {
  title: "Mary Freund",
  img: img,
  km: 0.7,
  category: "Makeup Artist",
  des: "Capturing moments and emotions that narrate unique stories is my passion.",
  rate: 4.1,
};

const PaidPayments = () => {
  const [loading, setloading] = useState(false);
  const [data, setdata] = useState([]);
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    setloading(true);
    dispatch(
      EventMiddleware.budgetPayments({
        status: "paid",
        event_id: state?.eventData?.id,
      })
    )
      .then((data) => {
        setdata(data);
        setloading(false);
      })
      .catch(() => {
        setloading(false);
      });
  }, []);
  return (
    <Skeleton loading={loading}>
      <Row className={styles.items} gutter={16}>
        {data.map((item) => (
          <Col xs={24} lg={12}>
            <Row
              className={styles.itemRow}
              onClick={
                item?.vendor
                  ? () =>
                      navigate(
                        "/events/budget/paymentTracking/payments/vendor",
                        {
                          state: {
                            headrTitle: "Vendor",
                            data: item,
                          },
                        }
                      )
                  : null
              }
            >
              <Col
                xs={{ span: 24 }}
                sm={{ span: 16 }}
                md={{ span: 16 }}
                lg={{ span: 12 }}
              >
                <TextComponent textClass={styles.itemTitle}>
                  {item?.category?.name}
                </TextComponent>
                <TextComponent textClass={styles.itemCategory}>
                  {item?.title}
                </TextComponent>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 8 }}
                md={{ span: 8 }}
                lg={{ span: 12 }}
              >
                <TextComponent textClass={styles.amount}>
                  {`$${item?.total_budget}`}
                </TextComponent>
                <TextComponent textClass={styles.status}>Paid</TextComponent>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Skeleton>
  );
};

export default PaidPayments;
